export function removeAt<E>(array: E[], index: number): E[] {
    const prefix = array.slice(0, index)
    const suffix = array.slice(index + 1, array.length)

    return prefix.concat(suffix)
}

export function replaceAt<E>(array: E[], index: number, e: E): E[] {
    return array.map((v, i) => (i === index ? e : v))
}

export function unique<E>(array: E[]): E[] {
    return array.filter((value, index) => array.indexOf(value) === index)
}

export function getDupes(arr: string[]): { [value: string]: number[] } {
    return arr.reduce<[string[], { [value: string]: number[] }]>(
        (p, c, i) => {
            if (p[0].includes(c)) {
                if (Array.isArray(p[1][c])) {
                    p[1][c].push(i)
                } else {
                    p[1][c] = [i]
                }
            } else {
                p[0].push(c)
            }
            return p
        },
        [[], {}]
    )[1]
}
